import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {BranchServiceStepContext} from "../../context/branch_service_step_context";
import {TableHead} from "../system/thead";
import TableTdContent from "../system/tableTdContent";
import {PaginateContext} from "../../context/paginate";


const TABLE_HEAD = ["#", "گرایش", "عنوان", "توضیحات", "مرحله", "وضعیت", "عملیات"];

export function BranchServiceStepGrid({BranchServiceSteps}) {

  const {setBranchServiceStep, setModalOpen} = useContext(BranchServiceStepContext);

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "گرایش": "branch_name",
    "عنوان": "title",
    "توضیحات": "description",
    "مرحله": "step",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "گرایش": true,
    "عنوان": true,
    "توضیحات": true,
    "مرحله": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {BranchServiceSteps.map(
          ({
             id,
             branch_name,
             title,
             description,
             step,
             status,
           }, index) => {
            const isLast = index === BranchServiceSteps.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <TableTdContent content={title} length={20}/>
                </td>

                <td className={classes}>
                  <TableTdContent content={description} length={20}/>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(step)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setBranchServiceStep(BranchServiceSteps[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}